import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import currency from 'currency.js'
import NumberFormat from 'react-number-format'

import { Submitting } from '../common/Submitting'

export const AvailableCredits = ({ availableCredits }) => (
  <div className="row start-xs">
    <div className="col-md-offset-3 col-xs-12 col-md-6">
      <label
        style={{
          paddingLeft: '7px',
          position: 'relative',
          top: '-10px'
        }}
        htmlFor="credit"
      >
        Total credits available:{' '}
        {currency(availableCredits, { formatWithSymbol: true }).format()}
      </label>
    </div>
  </div>
)

export const RemoveAppliedCredit = ({
  creditsUsed,
  value,
  error,
  setValue,
  applyCredit,
  isCreditApplying,
  isCheckoutCartLoading,
  availableCredits,
  isAvailableCreditsLoading
}) => (
  <Fragment>
    <div className="row middle-xs">
      <div className="col-xs-12 col-md-3 start-xs end-md">
        <label htmlFor="credit" style={{ margin: 0 }}>
          Credits Applied:{' '}
        </label>
      </div>
      <div className="col-xs-12 col-md-6">
        <NumberFormat
          displayType="text"
          prefix="$"
          value={creditsUsed}
          allowNegative={false}
          decimalScale={2}
          fixedDecimalScale
          renderText={formattedValue => <strong>{formattedValue}</strong>}
        />
      </div>
      <div className="col-xs-12 col-md-3 end-xs">
        {isCreditApplying || isCheckoutCartLoading ? (
          <Submitting text="Changing" />
        ) : (
          <button
            type="button"
            className="button secondary"
            onClick={() => {
              applyCredit(0)
              setValue(creditsUsed)
            }}
          >
            Change
          </button>
        )}
      </div>
    </div>
    {error && (
      <div className="slide error">
        {error.response.data.message || error.response.data}
      </div>
    )}
    {!isAvailableCreditsLoading && availableCredits ? (
      <AvailableCredits availableCredits={availableCredits} />
    ) : null}
  </Fragment>
)

export const AddCredit = ({
  value,
  error,
  setValue,
  applyCredit,
  isCreditApplying,
  isCheckoutCartLoading,
  availableCredits,
  isAvailableCreditsLoading
}) => (
  <Fragment>
    <div className="row middle-xs">
      <div className="col-xs-12 col-md-3 start-xs end-md">
        <label htmlFor="credit">Credit Amount</label>
      </div>
      <div className="col-xs-12 col-md-6">
        <NumberFormat
          displayType="input"
          prefix="$"
          value={value}
          allowNegative={false}
          decimalScale={2}
          fixedDecimalScale
          onValueChange={values => setValue(values.value)}
        />
        {error && (
          <div className="slide error">
            {error.response.data.message || error.response.data}
          </div>
        )}
      </div>
      <div className="col-xs-12 col-md-3 end-xs">
        {isCreditApplying ? (
          <Submitting text="Applying" />
        ) : (
          <button
            type="button"
            className="button secondary"
            disabled={!value || isCheckoutCartLoading}
            onClick={event => {
              event.preventDefault()
              applyCredit(value)
            }}
          >
            Apply
          </button>
        )}
      </div>
    </div>
    {!isAvailableCreditsLoading && availableCredits ? (
      <AvailableCredits availableCredits={availableCredits} />
    ) : null}
  </Fragment>
)

class ApplyCredit extends Component {
  constructor(props) {
    super(props)
    this.state = { value: props.suggestedCredits ? props.suggestedCredits : '' }
    this.setValue = this.setValue.bind(this)
  }

  // reset state if the seeded prop is updated
  componentDidUpdate(prevProps) {
    if (this.props.suggestedCredits !== prevProps.suggestedCredits) {
      this.setState({ value: this.props.suggestedCredits })
    }
  }

  setValue(value) {
    this.setState({ value: value })
  }

  render() {
    const {
      error,
      creditsApplied,
      creditsUsed,
      applyCredit,
      isCreditApplying,
      isCheckoutCartLoading,
      availableCredits,
      isAvailableCreditsLoading
    } = this.props
    return creditsApplied ? (
      <RemoveAppliedCredit
        creditsUsed={creditsUsed}
        applyCredit={applyCredit}
        setValue={this.setValue}
        error={error}
        value={this.state.value}
        isCreditApplying={isCreditApplying}
        isCheckoutCartLoading={isCheckoutCartLoading}
        availableCredits={availableCredits}
        isAvailableCreditsLoading={isAvailableCreditsLoading}
      />
    ) : (
      <AddCredit
        applyCredit={applyCredit}
        setValue={this.setValue}
        error={error}
        value={this.state.value}
        isCreditApplying={isCreditApplying}
        isCheckoutCartLoading={isCheckoutCartLoading}
        availableCredits={availableCredits}
        isAvailableCreditsLoading={isAvailableCreditsLoading}
      />
    )
  }
}

ApplyCredit.propTypes = {
  suggestedCredits: PropTypes.number,
  creditsApplied: PropTypes.bool,
  creditsUsed: PropTypes.number,
  applyCredit: PropTypes.func,
  isCreditApplying: PropTypes.bool,
  error: PropTypes.object,
  isCheckoutCartLoading: PropTypes.bool,
  availableCredits: PropTypes.number,
  isAvailableCreditsLoading: PropTypes.bool
}

export default ApplyCredit
